module.exports = __webpack_public_path__ + "static/media/NavHamburgerIcon.a786e666.svg";